/**
 * `formula` — **measured, and the biggest correction of the round.** `specs/M1-B4` §8.5 said
 * "`formula` and `mirror` columns are not offered"; monday offers a formula column nine
 * conditions. It filters on the *rendered* result, which is exactly what our `text_value`
 * shadow holds after `packages/formula` recomputes the cell.
 *
 * `is only` / `is anything but` are offered and not modelled (no public operator).
 */
import { CONTAINS, IS_EMPTY, IS_NOT_EMPTY, IS_NOT_TEXT, IS_TEXT, NOT_CONTAINS, STARTS_WITH, } from '../filter-conditions.js';
export const formulaFilterConditions = [
    IS_TEXT,
    IS_NOT_TEXT,
    IS_EMPTY,
    IS_NOT_EMPTY,
    CONTAINS,
    NOT_CONTAINS,
    STARTS_WITH,
];
//# sourceMappingURL=filters.js.map